/**
 * nxt means, a user is referred by a page which want the user to explicitly go to a specific application next.
 */

enum nxtEnum {
  QT = 'QT-LOGIN',
  M101 = 'M101',
}

export default nxtEnum;
